import React, { FC } from 'react'

import { InterSvgIcon } from 'components'

import { Text } from '@interco/inter-ui/components/Text'

import { WarningIconContainer, WarningSectionContainer } from './styles'

type WarningMessageProps = {
  icon: string
  details: string
  size: number
}

export const WarningMessage: FC<WarningMessageProps> = ({ icon, details, size }) => (
  <WarningSectionContainer>
    <WarningIconContainer $size={size}>
      <InterSvgIcon iconRef={icon} width={size} height={size} color="var(--gray300)" />
    </WarningIconContainer>
    <Text variant="caption-1" color="typography" colorWeight={500} fontWeight={400} as="p">
      {details}
    </Text>
  </WarningSectionContainer>
)
